"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./NotificationItemImage.css");
/**
 * @deprecated Should start using the same component migrated to UI2.
 */
function NotificationItemImage(_a) {
    var image = _a.image, backgroundColor = _a.backgroundColor, icon = _a.icon;
    return (react_1.default.createElement("div", { className: "dcl notification-image__container" },
        typeof image === 'string' ? (react_1.default.createElement("div", { className: "dcl notification-image", style: backgroundColor && {
                backgroundImage: "radial-gradient(".concat(backgroundColor, ")")
            } },
            react_1.default.createElement("img", { src: image, alt: "Notification Image" }))) : (image),
        icon && react_1.default.createElement("span", { className: "dcl notification-icon" }, icon)));
}
exports.default = NotificationItemImage;
